import { notification } from "antd";
import RequestHandler from "util/RequestHandler";

const PANEL_TYPE_PANEL = 0;

export { PANEL_TYPE_PANEL };

export const BANNER_SCREEN_POPUP = "Popup";

export function trackBannerClick({
  bannerId,
  screenName,
  panelType = PANEL_TYPE_PANEL,
  firmId = null,
}) {
  RequestHandler.post(
    "/Banner/TrackClick",
    {
      bannerId,
      screenName,
      panelType,
      firmId,
    },
    false,
  );
}

/**
 * @param {object} banner
 * @param {{ isLogin: boolean, isAdmin: boolean }} options
 * @returns {string|null|undefined} URL to open, or null if blocked
 */
export function resolveBannerTargetUrl(banner, { isLogin, isAdmin }) {
  if (isLogin) {
    if (!banner.isRedirectEveryone && !isAdmin) {
      notification.info({
        message: "Lütfen yöneticiniz ile görüşünüz.",
        duration: 3,
      });
      return null;
    }
    const token = localStorage.getItem("token");
    if (!banner.redirectUrl) {
      return "";
    }
    return banner.redirectUrl.replace("{token}", token || "");
  }
  return banner.redirectUrl;
}

const FINIKA_REGISTER_URL = "https://panel.finika.co/register";

export function openBannerTarget(target) {
  if (target && String(target).length > 0) {
    window.open(target, "_blank", "noopener,noreferrer");
  }
}
